// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../../node_modules/less-loader/dist/cjs.js!../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Rebate Rules Tab CSS Module
 * Rebate-specific rules content styles
 */
.E0882YJ2l85NjTYEh_tV {
}
.QjJnj6dB4rztmdVdnv_i {
}
.AwXsRCRyjXXEmdi3MaXf {
}
.T7HFXARWttJgB_OxPCBK {
}
.cLRxPc5TMOh2tjyUR1tl {
}
.BdwovSqyTe2slRNhEKwQ {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/tabs/RulesTab/RebateRulesContent/RebateRulesContent.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/**\n * Rebate Rules Tab CSS Module\n * Rebate-specific rules content styles\n */\n.title {\n  composes: title from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.section {\n  composes: section from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.highlightedText {\n  composes: highlightedText from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.list {\n  composes: list from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.listItem {\n  composes: listItem from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.emphasis {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `E0882YJ2l85NjTYEh_tV ${___CSS_LOADER_ICSS_IMPORT_0___.locals["title"]}`,
	"section": `QjJnj6dB4rztmdVdnv_i ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"highlightedText": `AwXsRCRyjXXEmdi3MaXf ${___CSS_LOADER_ICSS_IMPORT_0___.locals["highlightedText"]}`,
	"list": `T7HFXARWttJgB_OxPCBK ${___CSS_LOADER_ICSS_IMPORT_0___.locals["list"]}`,
	"listItem": `cLRxPc5TMOh2tjyUR1tl ${___CSS_LOADER_ICSS_IMPORT_0___.locals["listItem"]}`,
	"emphasis": `BdwovSqyTe2slRNhEKwQ`
};
export default ___CSS_LOADER_EXPORT___;
